import { useState } from "react";
import { useTranslation } from "react-i18next";
import useNotify from "hooks/useNotify";
import profileApi from "api/profile";

function useCreateNewMember({
  updateUsersResult = () => {},
  setPagination = () => {},
  defaultPagination = {},
}) {
  const [t] = useTranslation();

  const { notifyError, notifySuccess } = useNotify();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const onSubmit = async ({ email, firstName, lastName, ...rest }) => {
    try {
      setIsLoading(true);

      const userRatesId = Object.keys(rest.userRatesId).reduce(
        (acc, serviceId) => {
          if (
            rest.userRatesId[serviceId] &&
            Array.isArray(rest.userRatesId[serviceId])
          ) {
            acc = [...acc, ...rest.userRatesId[serviceId]];
          }
          return acc;
        },
        []
      );

      const subDomainsIds = Object.keys(rest.userDomains).reduce(
        (acc, domainId) => {
          if (
            rest.userDomains[domainId] &&
            Array.isArray(rest.userDomains[domainId])
          ) {
            acc = [...acc, ...rest.userDomains[domainId]];
          }
          return acc;
        },
        []
      );

      if (subDomainsIds.length <= 0) {
        notifyError(t("errorField", { field: t("Subdomain") }));
        return;
      }

      const payload = {
        userRatesId,
        email,
        firstName,
        lastName,
        subDomains: subDomainsIds,
      };
      await profileApi.createAgencyTeamMemberApi(payload);
      const data = await profileApi.getAgencyTeamApi({});
      updateUsersResult(data);
      setPagination(defaultPagination);
      notifySuccess(t("teamMemberCreatedSuccessMsg"));
      setIsOpen(false);
    } catch (err) {
      console.error(err);
      notifyError(err?.data?.error ?? err?.message ?? "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  return { isOpen, setIsOpen, onSubmit, isLoading };
}

export default useCreateNewMember;
